export default __webpack_public_path__ + "static/media/reminder.efa6bb06.svg";